import React from 'react'
import {GatsbyImage, getImage} from "gatsby-plugin-image";

class HeroImageImage extends React.Component {
  render() {
    const { fileEdges, imagePath } = this.props

    const idx = fileEdges.findIndex((x) =>
        x.node.absolutePath.endsWith(imagePath))

    if (idx > -1) {
      return (
        <GatsbyImage
          className="lightboxIgnore"
          image={getImage(fileEdges[idx].node.childImageSharp)}
          alt="image"
        />
      )
    } else {
      return null
    }
  }
}

export default HeroImageImage
